export const INVENTORY_ITEM_COUNT = 25;
export const INVENTORY_MIN_SLOT_SIZE = 35;
export const INVENTORY_MAX_SLOT_SIZE = 56;
export const INVENTORY_DEFAULT_COLUMNS = 5;
export const INVENTORY_SLOT_GAP = 8;

function normalizeDimension(value) {
  const number = Number(value);
  return Number.isFinite(number) && number > 0 ? number : null;
}

export function calculateInventoryLayout(width, height, options = {}) {
  const itemCount = options.itemCount ?? INVENTORY_ITEM_COUNT;
  const minSlotSize = options.minSlotSize ?? INVENTORY_MIN_SLOT_SIZE;
  const maxSlotSize = options.maxSlotSize ?? INVENTORY_MAX_SLOT_SIZE;
  const gap = options.gap ?? INVENTORY_SLOT_GAP;
  const columns = Math.min(options.columns ?? INVENTORY_DEFAULT_COLUMNS, itemCount);
  const rows = Math.ceil(itemCount / columns);
  const availableWidth = normalizeDimension(width);
  const availableHeight = normalizeDimension(height);

  if (!availableWidth || !availableHeight) {
    return {
      columns,
      rows,
      slotSize: maxSlotSize,
    };
  }

  const widthSlotSize = (availableWidth - Math.max(0, columns - 1) * gap) / columns;
  const heightSlotSize = (availableHeight - Math.max(0, rows - 1) * gap) / rows;
  const availableSlotSize = Math.min(widthSlotSize, heightSlotSize);
  const slotSize = Math.min(maxSlotSize, Math.max(minSlotSize, availableSlotSize));

  return {
    columns,
    rows,
    slotSize: Math.round(slotSize * 100) / 100,
  };
}
